export const FETCH_POSTS = 'FETCH_POSTS';
export const NEW_POST = 'NEW_POST';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const ADD_SITE_ELEMENT = 'ADD_SITE_ELEMENT'
export const REQUEST_NEW_SITE = 'REQUEST_NEW_SITE'
export const POST_FAILED = 'POST_FAILED'
export const ADD_URL = 'ADD_URL'
export const ADD_NAME = 'ADD_NAME'
export const ADD_TITLE = 'ADD_TITLE'
export const ADD_CONFIDENTIALITY = 'ADD_CONFIDENTIALITY'
export const ADD_ONLINE_LOCATION = 'ADD_ONLINE_LOCATION'
export const ADD_EXTERNALCOLLABORATION = 'ADD_EXTERNALCOLLABORATION'
export const ADD_PURPOSE = 'ADD_PURPOSE'
export const ADD_QUOTA = 'ADD_QUOTA'
export const ADD_TEMPLATE = 'ADD_TEMPLATE'
export const ADD_GDPR = 'ADD_GDPR'
export const ADD_SENSITIVE_GDPR = 'ADD_SENSITIVE_GDPR'
export const CONFIRM_GDPR = 'CONFIRM_GDPR'
export const ADD_OWNER = 'ADD_OWNER'
export const ADD_APPROVER = 'ADD_APPROVER'
export const ADD_AUTHOR = 'ADD_AUTHOR'
export const ADD_LOCATION = 'ADD_LOCATION'
export const ADD_PMOS = 'ADD_PMOS'
export const ADD_PROJECT_MANAGER = 'ADD_PROJECT_MANAGER'
export const ADD_SPONSOR = 'ADD_SPONSOR'
export const ADD_STEERING_COMMITTEE = 'ADD_STEERING_COMMITTEE'
export const ADD_MEMBERS = 'ADD_MEMBERS'

export const IS_LOGGED = 'IS_LOGGED'
export const GET_CURRENT_USER = 'GET_CURRENT_USER'
export const GET_USER_MANAGER = 'GET_USER_MANAGER'

export const GET_SITE_NUMBER = 'GET_SITE_NUMBER'

export const CLEAR_ERROR = 'CLEAR_ERROR'
export const CLEAR_ERROR_PANEL = 'CLEAR_ERROR_PANEL'

export const SET_NAME_VALID = 'SET_NAME_VALID'
export const SET_TITLE_VALID = 'SET_TITLE_VALID'
export const SET_QUOTA_VALID = 'SET_QUOTA_VALID'
export const SET_PURPOSE_VALID ='SET_PURPOSE_VALID'
export const SET_EXTERNAL_VALID ='SET_EXTERNAL_VALID';
export const SET_TEMPLATE_VALID ='SET_TEMPLATE_VALID';
export const SET_ORDER_CREATED = 'SET_ORDER_CREATED';
export const CLEAR_SITE_ELEMENTS = 'CLEAR_SITE_ELEMENTS'

export const SET_CONFIDENTIALITY_VALID = 'SET_CONFIDENTIALITY_VALID'

export const SET_GEOGRAPHY = 'SET_GEOGRAPHY'
export const SET_MANAGEMENT = 'SET_MANAGEMENT'

export const SET_ONPREMISE_STATE= 'SET_ONPREMISE_STATE'

export const NEXT_STEP_REQUEST = 'NEXT_STEP_REQUEST'
export const FREEZE_WIZARD = 'FREEZE_WIZARD'

export const GET_DATA_SUCCESS = 'GET_DATA_SUCCESS'
export const GET_DATA_FAILED = 'GET_DATA_FAILED'

export const SET_STEP_VALIDATION = 'SET_STEP_VALIDATION'

export const STEP_COMPLETED = 'STEP_COMPLETED'

export const GET_QUOTAS = 'GET_QUOTAS'
export const SET_SECURITY_LEVELS = 'SET_SECURITY_LEVELS'
export const SET_CURRENT_STEP = 'SET_CURRENT_STATE'

export const RESET_STEP1_VALIDATION = 'RESET_STEP1_VALIDATION';
export const RESET_STEP2_VALIDATION = 'RESET_STEP2_VALIDATION';
export const RESET_WIZARD_CACHE = 'RESET_WIZARD_CACHE';

export const SET_NAVIGATION_KEY = 'SET_NAVIGATION_KEY';

export const SET_APP_HOST = 'SET_APP_HOST';
export const GET_CONFIDENTIALITY_LEVELS = 'GET_CONFIDENTIALITY_LEVELS';
export const GET_LOCATIONS = 'GET_LOCATIONS';

export const SET_NAVIGATION_PIVOT_ITEM = 'SET_NAVIGATION_PIVOT_ITEM'

export const GET_MESSAGE_BARS = 'GET_MESSAGE_BARS'

export const ADD_IDGINTEGRATION = 'ADD_IDGINTEGRATION'

export const GET_APP_CONFIGURATION = 'GET_APP_CONFIGURATION'


// WEBPACK FOOTER //
// ./src/actions/types.js